const FocedLocked = () => (
  <svg
    width="144"
    height="145"
    viewBox="0 0 144 145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="72" cy="72.5" r="72" fill="url(#paint0_linear_2196_40150)" />
    <path
      d="M87.5832 67.75H84.7498V55C84.7498 47.9578 79.0421 42.25 71.9998 42.25C64.9576 42.25 59.2498 47.9578 59.2498 55V67.75H56.4165V55C56.4165 46.3938 63.3936 39.4167 71.9998 39.4167C80.6061 39.4167 87.5832 46.3938 87.5832 55V67.75Z"
      fill="url(#paint1_linear_2196_40150)"
    />
    <path
      d="M94.6666 66.3334H49.3333C46.9858 66.3334 45.0833 68.236 45.0833 70.5834V100.333C45.0833 102.681 46.9858 104.583 49.3333 104.583H94.6666C97.014 104.583 98.9166 102.681 98.9166 100.333V70.5834C98.9166 68.236 97.014 66.3334 94.6666 66.3334Z"
      fill="url(#paint2_linear_2196_40150)"
    />
    <path
      d="M79.0832 81.9167C79.0832 78.0053 75.9113 74.8334 71.9998 74.8334C68.0884 74.8334 64.9165 78.0053 64.9165 81.9167C64.9165 85.3436 67.3503 88.201 70.5832 88.857V94.6667C70.5832 95.4487 71.2164 96.0834 71.9998 96.0834C72.7833 96.0834 73.4165 95.4487 73.4165 94.6667V88.857C76.6493 88.201 79.0832 85.3436 79.0832 81.9167Z"
      fill="url(#paint3_linear_2196_40150)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2196_40150"
        x1="72"
        y1="80"
        x2="-2.80142e-06"
        y2="0.999999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDEBE6" stopOpacity="0.96" />
        <stop offset="1" stopColor="#EDEBE6" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2196_40150"
        x1="71.9998"
        y1="39.4167"
        x2="71.9998"
        y2="67.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0E0E6" />
        <stop offset="1" stopColor="#C2C3CD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2196_40150"
        x1="71.9999"
        y1="66.3334"
        x2="71.9999"
        y2="104.583"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD36E" />
        <stop offset="1" stopColor="#F6B828" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2196_40150"
        x1="71.9998"
        y1="74.8334"
        x2="71.9998"
        y2="103.158"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C88509" />
        <stop offset="1" stopColor="#F6B828" />
      </linearGradient>
    </defs>
  </svg>
)

export default FocedLocked
